import React from "react";
import { StyledImpactBox } from "./ImpactBox.styled";
import { TitlesTyp } from "../Typography/Typography";
import { theme } from "../../constants/StyledComponents";
import { FontWeightEnum } from "../../types/AppTypes";

type ImpactBoxProps = {
  value: number;
};

export const ImpactBox = ({ value }: ImpactBoxProps) => (
  <StyledImpactBox>
    <TitlesTyp
      variant="3"
      fontWeight={FontWeightEnum.SEMIBOLD}
      color={theme.colors.purple}
      noTranslate
    >
      {value}
    </TitlesTyp>
  </StyledImpactBox>
);
